export const useFatalErrors = (errors: string[], fatalErrors: string[]) => {
	if (errors.some(error => fatalErrors.includes(error))) {
		if (IS_CLIENT) {
			window.location.reload()
		}
	}
}
